

export enum ReceivePaymentDialogType {
    SinglePayment = "SinglePayment",
    MultiPayment = "MultiPayment",
    ViewPaymentDetails = "ViewPaymentDetails",
    Edit = "Edit",
}

export const UnderPay = [
    { id: 1, name: "Leave amount as underpayment.", code: "leave amount" },
    { id: 2, name: "Write off the extra amount.", code: "write off" },
];

export const ModuleName = {
    'Invoicing' : '',
    'Sales Order' : ''
}